import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { logoutUser } from '../services/auth'
import { LogIn, UserPlus, LogOut, LayoutDashboard, ChevronDown, Menu, X } from 'lucide-react'
import './Header.css'

const Header = () => {
  const { user, loading } = useAuth()
  const navigate = useNavigate()
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  const handleLogout = async () => {
    await logoutUser()
    navigate('/')
  }

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false)
  }

  return (
    <header className="header">
      <div className="header-content">
        <div className="logo-section">
          <Link to="/" className="logo-link" onClick={closeMobileMenu}>
            <img
              src="https://res.cloudinary.com/dcm2dsjov/image/upload/v1757627650/Agregar_un_subt%C3%ADtulo_10_irdlej.png"
              alt="VTIC Logo"
              className="header-logo"
            />
            <div className="logo-text">
              <h1 className="brand-name">VTIC</h1>
              <p className="brand-subtitle">Voluntariado de Tutores e Investigación Científica</p>
            </div>
          </Link>

          <button 
            className="mobile-menu-toggle" 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle mobile menu"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        <nav className={`header-nav ${isMobileMenuOpen ? 'open' : ''}`}>
          <Link to="/" className="nav-link" onClick={closeMobileMenu}>Inicio</Link>
          <Link to="/biblioteca" className="nav-link" onClick={closeMobileMenu}>Biblioteca</Link>
          
          <div className="dropdown">
            <button className="dropdown-toggle">
              Tutorías <ChevronDown size={14} className="dropdown-icon" />
            </button>
            <div className="dropdown-menu">
              <Link to="/secciones" className="dropdown-item" onClick={closeMobileMenu}>Catálogo de Materias</Link>
              <Link to="/tutores" className="dropdown-item" onClick={closeMobileMenu}>Nuestros Tutores</Link>
              <Link to="/mural-retiro" className="dropdown-item" onClick={closeMobileMenu}>Mural de Retiro</Link>
              <Link to="/como-ser-tutor" className="dropdown-item" onClick={closeMobileMenu}>¿Cómo ser Tutor?</Link>
            </div>
          </div>

          <div className="dropdown">
            <button className="dropdown-toggle">
              Investigación <ChevronDown size={14} className="dropdown-icon" />
            </button>
            <div className="dropdown-menu">
              <Link to="/grupos-investigacion" className="dropdown-item" onClick={closeMobileMenu}>Grupos de Investigación</Link>
              <Link to="/como-unirse-investigacion" className="dropdown-item" onClick={closeMobileMenu}>¿Cómo Unirse?</Link>
              <Link to="/crear-grupo-investigacion" className="dropdown-item" onClick={closeMobileMenu}>¿Cómo Crear un Grupo?</Link>
            </div>
          </div>

          <div className="dropdown">
            <button className="dropdown-toggle">
              Voluntariado <ChevronDown size={14} className="dropdown-icon" />
            </button>
            <div className="dropdown-menu">
              <Link to="/nosotros" className="dropdown-item" onClick={closeMobileMenu}>¿Quiénes Somos?</Link>
              <Link to="/muro" className="dropdown-item" onClick={closeMobileMenu}>Muro de VTIC</Link>
              <Link to="/reglamento" className="dropdown-item" onClick={closeMobileMenu}>Reglamento de Voluntariado</Link>
            </div>
          </div>

          {!loading && (
            <div className="auth-buttons">
              {user ? (
                <>
                  <Link to="/dashboard" className="auth-button dashboard-button" onClick={closeMobileMenu}>
                    <LayoutDashboard size={18} />
                    Dashboard
                  </Link>
                  <button
                    onClick={() => { handleLogout(); closeMobileMenu(); }}
                    className="auth-button logout-button"
                  >
                    <LogOut size={18} />
                    Salir
                  </button>
                </>
              ) : (
                <>
                  <Link to="/login" className="auth-button login-button" onClick={closeMobileMenu}>
                    <LogIn size={18} />
                    Entrar
                  </Link>
                  <Link to="/register" className="auth-button register-button" onClick={closeMobileMenu}>
                    <UserPlus size={18} />
                    Registrase
                  </Link>
                </>
              )}
            </div>
          )}
        </nav>
      </div>
    </header>
  )
}

export default Header

// force refresh
